// extracted by mini-css-extract-plugin
export default {"alerticon":"index_alerticon__8KhUw","emailtag":"index_emailtag__WhEYG"};